import * as React from 'react';

// tslint:disable:max-line-length
export const ArrowDownIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8">
    <path
      fill="#2B87DB"
      fillRule="evenodd"
      d="M10.046.335L6 4.38 1.953.335A1.144 1.144 0 0 0 .336 1.954L5.19 6.809a1.144 1.144 0 0 0 1.619 0l4.855-4.855a1.146 1.146 0 0 0-1.619-1.62z"
    />
  </svg>
);
